import { defineStore } from 'pinia'

export const useSysTempStore = defineStore('sysTempStore', {
    state: () => ({
        isLoadedShipping: false,       // 是否已經撈過資料
        shippingMethods: [],
        isLoadedPayment: false,       // 是否已經撈過資料
        paymentMethods: [],
    }),
    actions: {
        async fetchShippingData() {
            if (this.isLoadedShipping) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/load/shipping')
                const json = await res.json()
                if (json.success) {
                    this.shippingMethods = json.shippingMethods
                    this.isLoadedShipping = true
                } else {
                    console.warn('取得輪播資料失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
        async fetchPaymentData() {
            if (this.isLoadedPayment) return // 已載入過就直接 return
            try {
                const res = await fetch('/api/load/payment')
                const json = await res.json()
                if (json.success) {
                    this.paymentMethods = json.paymentMethods
                    this.isLoadedPayment = true
                } else {
                    console.warn('取得輪播資料失敗', json.message)
                }
            } catch (err) {
                console.error('fetch error:', err)
            }
        },
    },
})
